import { c as _c } from "react/compiler-runtime";
import React, { useState } from "react";
import AnimateHeight from "react-animate-height";
import { ChevronDown } from "react-feather";
import { PortableText } from "next-sanity";
import { CauseAreaDisplayConfig } from "../../../types/WidgetProps";
import { Links } from "../../../../../../main/blocks/Links/Links";
import { RolloutAccordion } from "../../panes/AmountPane.style";
import { useIsMobile } from "../../../../../../../hooks/useIsMobile";
interface CauseAreaRolloutProps {
  causeAreaId: number;
  config?: CauseAreaDisplayConfig;
}
export const CauseAreaRollout: React.FC<CauseAreaRolloutProps> = t0 => {
  const $ = _c(27);
  const {
    causeAreaId,
    config
  } = t0;
  const [open, setOpen] = useState(false);
  const isMobile = useIsMobile();
  let t1;
  if ($[0] !== causeAreaId || $[1] !== config?.cause_area_rollouts) {
    t1 = config?.cause_area_rollouts?.find(item => item.cause_area_id === causeAreaId);
    $[0] = causeAreaId;
    $[1] = config?.cause_area_rollouts;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const rollout = t1;
  if (!rollout?.title) {
    return null;
  }
  let t2;
  if ($[3] !== open) {
    t2 = () => setOpen(!open);
    $[3] = open;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== rollout.title) {
    t3 = <span>{rollout.title}</span>;
    $[5] = rollout.title;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const t4 = open ? "rotate(180deg)" : "rotate(0deg)";
  let t5;
  if ($[7] !== t4) {
    t5 = <ChevronDown size={28} style={{
      transform: t4,
      transition: "transform 0.3s ease"
    }} />;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t2 || $[10] !== t3 || $[11] !== t5) {
    t6 = <div onClick={t2}>{t3}{t5}</div>;
    $[9] = t2;
    $[10] = t3;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  const t7 = open ? "auto" : 0;
  let t8;
  if ($[13] !== rollout.text) {
    t8 = rollout.text && <PortableText value={rollout.text} />;
    $[13] = rollout.text;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== isMobile || $[16] !== rollout.links) {
    t9 = rollout.links && <Links links={rollout.links} newtab={isMobile} />;
    $[15] = isMobile;
    $[16] = rollout.links;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t8 || $[19] !== t9) {
    t10 = <div>{t8}{t9}</div>;
    $[18] = t8;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== t10 || $[22] !== t7) {
    t11 = <AnimateHeight height={t7}>{t10}</AnimateHeight>;
    $[21] = t10;
    $[22] = t7;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== t11 || $[25] !== t6) {
    t12 = <RolloutAccordion>{t6}{t11}</RolloutAccordion>;
    $[24] = t11;
    $[25] = t6;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  return t12;
};